import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import ReserveMenuModelEdit from './ReserveMenuModelEdit';
import ReserveMenuStyle from './ReserveMenuStyle';
import { SocketContext } from '../../../App';
import { useContext, useEffect, useRef, useState } from 'react';
import { Button, Popconfirm, Space, Switch } from 'antd';
import ReserveMenuModelUploadFile from "./ReserveMenuModelUploadFile";
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import antMessage from '../../../utils/extend/AntdNotification';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';

export default function ReserveMenuModel(props: any) {

    const ref = useRef<any>(undefined);
    const notificationApi = useNotificationInstance();

    /** api服务id */
    const apiId = 'reserveMenuModel';

    /** 后端数据wmService */
    let wmService: any = systemConfig.wmService;

    //样式数据
    const [styleData, setStyleData] = useState<any>();

    //结构样式窗口
    const [reserveMenuStyleVisible, setReserveMenuStyleVisible] = useState(false);

    const useContextData = useContext(SocketContext);
    const { contextData, setContextData } = useContextData;

    useEffect(() => {

        if (contextData?.currentBranchStoreId) {
            if (contextData?.refresh) {
                onRefresh({ brandId: contextData?.currentBrandId, branchStoreId: contextData?.currentBranchStoreId })
            }
        }

        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contextData?.currentBranchStoreId]); //初始化数据

    const onRefresh = (item: any) => {
        const { brandId, branchStoreId } = item;
        const currentData: initDataType = {
            apiId,
            sendPageData: {
                brandId,
                branchStoreId
            }
        }
        ref.current.initData(currentData);

        setContextData({ ...contextData, refresh: false })
    }

    //打开结构样式
    const handleReserveMenuStyle = (e: any) => {
        sendData.id = e.id;
        sendData.brandId = e.brandId;
        sendData.brandName = e.brand.brandName;
        sendData.reserveMenuModelName = e.reserveMenuModelName;
        setStyleData(sendData);
        setReserveMenuStyleVisible(true);
    };

    const initData = async () => {
        const currentData: initDataType = {
            apiId,
        }
        ref.current.initData(currentData);
    }

    //执行复制模板
    const handleCopy = (e: any) => {
        fetchApi.POST(wmService, {
            apiId,
            apiExtend: 'copy',
            apiData: {
                reserveMenuModelId: e.id
            }
        }).then(async res => {
            if (res.success) {
                antMessage('success', '复制成功', 'success');
                await initData();
            }
        })
    }

    //表头
    const columnsHead = [
        {
            title: '品牌',
            dataIndex: 'brand',
            render: (text: any, record: any) => {
                return (
                    <div>{record.brand.brandName}</div>
                )
            }
        },
        {
            title: '门店',
            dataIndex: 'branchStoreName',
            render: (text: any, record: any) => {
                if (record.branchStore) {
                    return (
                        // <div>{record.branchStore.brand.brandName + " " + record.branchStore.branchStoreName}</div>
                        <div>{record.branchStore.branchStoreName}</div>
                    )
                }
            }
        },
        {
            title: '模板名',
            dataIndex: 'reserveMenuModelName',
        },
        {
            title: '结构样式',
            dataIndex: 'style',
            key: 'style',
            render: (text: any, record: any) => {
                return <Space size="small">
                    <Button size={"small"} type="primary" onClick={() => handleReserveMenuStyle(record)}>结构样式</Button>
                </Space>
            }
        },
        {
            title: '复制模板',
            dataIndex: 'copy',
            key: 'copy',
            render: (text: any, record: any) => {
                return <Space size="small">
                    <Popconfirm title="是否确定复制一份相同的模板?"
                        onConfirm={() => handleCopy(record)}>
                        <Button size={"small"} type="primary">复制模板</Button>
                    </Popconfirm>
                    {/* <Button size={"small"} type="primary" onClick={() => handleCopy(record)}>复制模板</Button> */}
                </Space>
            }
        },
        {
            title: '是否共用',
            dataIndex: 'isPublic',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '默认',
            dataIndex: 'changeDefault',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={record.id === record.defaultId ? true : false} key={record.id}
                    onChange={(e) => changeDefault(record.id, e)}
                />
            )
        }
    ];

    //改变数据
    const changeDefault = async (id: any, isValue: boolean) => {
        const bodys = {
            apiId: "reserveMenuModel",
            apiVariable: id,
            apiExtend: "changeDefault",
            apiData: {
                isValue,
                branchStoreId: contextData?.currentBranchStoreId
            }
        }
        fetchApi.PUT(wmService, bodys).then(res => {
            showCustomNotification(notificationApi!, {
                type: 'success',
                message: '编辑成功',
                description: 'success',
            });;
            onRefresh({ brandId: contextData?.currentBrandId, branchStoreId: contextData?.currentBranchStoreId })
        }).catch(err => {
            antMessage('error', '删编辑失败', err.message);
        })
    };

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式预订模板',
        apiId: 'reserveMenuModel',
        columns,
        showStates: true,
        // showDefault: true,
        showImage: true,
        showUploadFile: true,
        pagination: true,
        // extendIdName: "brandId",
        EditComponent: ReserveMenuModelEdit,
        arrayFilesName: 'reserveMenuModelFiles',
        UploadFileComponent: ReserveMenuModelUploadFile,
        sendPageData: { brandId: contextData?.currentBrandId, branchStoreId: contextData?.currentBranchStoreId },
        mountDataOptions: {
            userMount: {
                isBrand: true
            }
        }
    };

    //传关参数
    let sendData = {
        type: 'EDIT',
        key: '',
        id: '',
        brandId: '',
        brandName: '',
        reserveMenuModelName: ''
    }

    return (
        <>
            <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
            {reserveMenuStyleVisible
                ? (<ReserveMenuStyle
                    closeModal={setReserveMenuStyleVisible} data={styleData} />)
                : null}
        </>
    )
}